const LOAD_DATA_EMAIL           = 'LOAD_DATA_EMAIL'
const LOAD_DATA_EMAIL_SUCCESS   = 'LOAD_DATA_EMAIL_SUCCESS'
const LOAD_DATA_EMAIL_FAILED    = 'LOAD_DATA_EMAIL_FAILED'
const UNMOUNT_DATA_EMAIL        = 'UNMOUNT_DATA_EMAIL'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const emailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_EMAIL:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_EMAIL_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_EMAIL_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_EMAIL:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default emailReducer;